module.exports = __webpack_public_path__ + "static/rendition-200w-example-f39b906225582cb23724e66f31da7df2.gif";